


















import { Component, Vue, Prop } from 'vue-property-decorator'
import BaseClass from '../../virtual-class/baseClass'
import { UserModule } from '../../store/modules/user'
@Component
export default class SelectDepartment extends Vue {
  @Prop({ type: Array }) value!: any[]
  private get _value() {
    return this.value
  }
  private set _value(val) {
    this.$emit('input', val)
  }
  private get options() {
    return UserModule.orgDeptList.map(_ => ({
      value: String(_.id),
      label: _.name,
    }))
  }
}
